import { render, staticRenderFns } from "./TransferManager.vue?vue&type=template&id=2aafca01&scoped=true&"
import script from "./TransferManager.vue?vue&type=script&lang=js&"
export * from "./TransferManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aafca01",
  null
  
)

export default component.exports